export enum EStatisticsExportScheduleType {
  DAILY_WEEKDAYS = 'Daily (Weekdays)',
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
}

export enum EStatisticsExportTriggerType {
  MANUAL = 'Manual',
  SCHEDULED = 'Scheduled',
}

export enum EStatisticsExportExecutionStatus {
  PENDING = 'Pending',
  SUCCESS = 'Success',
  FAILED = 'Failed',
  CANCELED = 'Canceled',
}
